import { ModalQuickView } from './ui/ModalQuickView/ModalQuickView.jsx'
export default ModalQuickView
